import styled from "styled-components";

export const ImgContainer = styled.div`
  display: none;
  @media (max-width: 480px) {
    position: relative;
    display: block;
    width: 100%;
    margin-top: 115px;
    &::before {
      position: absolute;
      background-image: url("fade.png");
      background-repeat: no-repeat;
      background-size: 470px 331px;
      top: -86px;
      width: 100%;
      height: 100%;
      z-index: 10;
      content: "";
    }
    & img {
      box-shadow: inset 5px 5px 10px white;
      object-fit: cover;
      width: 100%;
      height: 281px;
      margin-top: 2.4rem;
    }
  }
`;
